import { HStack, Spinner, Stack, Table } from "@chakra-ui/react"
import { Text } from "@/components"
import { CashFlow } from "@/api/payments"

interface Props {
  cashFlows: CashFlow[]
  isLoading: boolean
}

export const PaymentLedgerSection = ({ cashFlows, isLoading }: Props) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(amount)
  }

  const formatDate = (dateStr: string) => {
    try {
      return new Date(dateStr).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    } catch {
      return dateStr
    }
  }

  return (
    <Stack>
      <Text fontSize="lg" fontWeight="semibold">
        Payment History
      </Text>

      {isLoading ? (
        <HStack w="100%" justifyContent="center" p={6}>
          <Spinner />
        </HStack>
      ) : cashFlows.length === 0 ? (
        <Text color="gray.500" p={4}>
          No payment history yet.
        </Text>
      ) : (
        <Table.Root size="sm" mt={2}>
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeader>Date</Table.ColumnHeader>
              <Table.ColumnHeader>Amount</Table.ColumnHeader>
              <Table.ColumnHeader>Memo</Table.ColumnHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {cashFlows.map((cf, index) => (
              <Table.Row key={cf.id ?? index}>
                <Table.Cell>{formatDate(cf.date)}</Table.Cell>
                <Table.Cell>{formatCurrency(cf.amount)}</Table.Cell>
                <Table.Cell>{cf.memo || "\u2014"}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Root>
      )}
    </Stack>
  )
}
